import * as oneDS from "@microsoft/1ds-analytics-web-js";
import { IUserBiLog } from "./abstractions";

// TODO(oskhare): check if this comes from a .env file since in old client it was under a const file 
const oneDsInstrumentationKey = "79e3a208c99846bb928947c2d9605feb-74353774-1476-4bb2-81f0-80180cb15fb1-7142"
const oneDsWebAnalyticsConfig = {
  autoCapture: {
    pageView: true,
    onLoad: true,
    click: true,
    scroll: false,
    onUnload: false
  }
};

const vNextTableName = "VNextTelemetry";

const getCommitHash = () => {
  return document.head.dataset["commitHash"] ?? "";
};

const getBuildDate = () => {
  return document.head.dataset["buildDate"] ?? "";
};

const getEnvironment = (s: string): 'local' | 'int' | 'prod' => {
  return (s === 'localhost' ? 'local'
    : s.includes('int') ? 'int' : 'prod'
  )
}

const shouldLogToConsole = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const logToConsole = urlParams.get('enableLocalLogging');
  const isLocal = getEnvironment(window.location.hostname) === 'local';
  return !!logToConsole || isLocal;
}


export default class OneDsTelemetry {
  private static oneDs: oneDS.ApplicationInsights;
  private static sessionId: string;
  private static environment: 'local' | 'int' | 'prod';
  private static isConsoleLoggingEnabled: boolean = false;


  public static initOneDs() {
    this.sessionId = crypto.randomUUID().toString();
    this.environment = getEnvironment(window.location.hostname);
    this.isConsoleLoggingEnabled = shouldLogToConsole();

    this.oneDs = new oneDS.ApplicationInsights();

    const config: oneDS.IExtendedConfiguration = {
      instrumentationKey: oneDsInstrumentationKey,
      extensions: [],
      webAnalyticsConfiguration: oneDsWebAnalyticsConfig as oneDS.IWebAnalyticsConfiguration,
    };

    this.oneDs.initialize(config, []);
    const propertyManager = this.oneDs.getPropertyManager();
    propertyManager.getPropertiesContext().session.setId(this.sessionId);
    propertyManager.setProperty("AppInfo.Host", "web");
    propertyManager.setProperty("AppInfo.BuildDate", getBuildDate());
    propertyManager.setProperty("AppInfo.CommitHash", getCommitHash());
    propertyManager.setProperty("Environment", this.environment);
  }

  public static setUserInfo(tenantId: string | null, aadId: string | null) {
    if (!this.oneDs) {
      console.error("OneDsTelemetry is not initialized.");
      return;
    }
    const propertyManager = this.oneDs.getPropertyManager();
    propertyManager.getPropertiesContext().user.localId = aadId ? `a:${aadId}` : "";
    propertyManager.setProperty("UserInfo.TenantId", tenantId ?? "");
  }

  private static createTelemetryPayload(tableName: string, eventData: IUserBiLog)
    : oneDS.IExtendedTelemetryItem {
    const result = {
      data: {
        ...eventData,
      },
      name: tableName
    };
    return result;
  }

  public static logUserBi(eventData: IUserBiLog) {
    if (this.environment === 'prod') {
      const telemetryPayload = this.createTelemetryPayload(vNextTableName, eventData);
      this.oneDs.trackEvent(telemetryPayload);
    }
    if (this.isConsoleLoggingEnabled) {
      console.log("OneDsUserBi", eventData);
    }
  }

};